export const BOOST_K_5 = [
  'e5cc09bf-5794-4dc8-9a1d-2a58928272be',
  '74299b43-1ac3-422a-85bb-4210bbba7467',
  'a507ecf4-d4c9-4a7e-8ade-1147c959adfc',
  'ffec4b66-5e53-4aaa-b06c-bc616a77b9ab',
];

export const BOOST_LECTURA_K_3 = [
  '7d549dac-f21f-4f20-a539-5251b92d2ff5',
  'd0a9820e-1157-4bcf-90bb-1d76e596624a',
  '915e8323-f880-4310-8004-1bd8fb5c4292',
  '8e8e1d56-854c-4662-9668-cd9e804a910a',
];

export const BOOST_4_5 = [
  '0606029c-78bd-48c3-8372-ce2d51051919',
  '285487bf-6d73-45f6-a05a-36dbef75ef9b',
];

export const CLOSE_READING = [
  'ad85a042-8d3a-4023-a751-96ffbb7961bc',
  '46b89259-792b-4fbd-9529-2d3144149b0d',
  '02d32c5a-17d0-4d79-ae1e-9b24d90fe2a3',
];

export const AMPLIFY_MCLASS_ASSET = '6a82c1ff-4da0-4560-b652-c470c19cecec';
export const AMPLIFY_OLD_MCLASS_ASSET = '57463d0d-a4f9-4206-a776-d51bcd0e609c';
export const AMPLIFY_HUB_ASSET = '3d24a52f-f5ed-4bc6-aca4-de547e57365f';
export const AMPLIFY_ELEMENTARY_STUDENT_APPS_ASSET =
  '6e74e98d-3e49-4612-8211-18779af0769a';
export const SCIENCE_APPS_ASSET = '6e74e98d-3e49-4612-8211-18779af0769a';
export const FLUENCY_PRACTICE_ASSET = '90557424-eb20-4a84-a79f-0e2d5c5e5f6e';
export const POLYPAD_ASSET = '25521919-c97f-435d-acc5-446112655200';
export const TX_ASSET_BK = '1fcad967-4656-4b63-98c6-566a44e19e9b';
export const FORMULA_WON_ASSET = '719830c1-65d1-4842-970e-cde639711708';
export const TWELVE_A_DOZEN_ASSET = '46c83777-26f8-406e-91c8-a7d9f48da0bd';
export const NUMBER_JUMPER_ASSET = '2ff3a2c7-94fb-4d09-853b-c30e70cbce6c';
export const CONNECT_THE_BLOCKS_ASSET = '3abee149-0c7f-4510-b56c-97356b34d505';

export const MS_APPS_SECTION_ASSETS = [
  '57463d0d-a4f9-4206-a776-d51bcd0e609c',
  '678443b0-c26e-4b4a-98a7-42ce9150b975',
  'bb480a75-05c3-4df0-9888-3d11ba56d312',
  '87b37f19-630a-42b1-9ca3-aba65cc079f9',
  '9b4b384c-7fd8-42bb-90d5-e11ad6f25c1d',
  'a56fcc7a-9410-4459-a4f6-4fbabd84d645',
  '4148fd95-a071-41e2-924e-8b47ef2dc21e',
  '9ce2c7da-dd03-448d-a787-d5634bc8a9cc',
  '1ee0b6c6-da19-40ec-8022-d49c9174b870',
  '194f1913-b0d5-4433-86cd-b66d14f37efb',
  '1a611196-90bc-4e0c-bf0d-b4123365c853',
  '487c59a1-2503-4f11-b884-89fb085200a0',
  'a8eb4e05-233b-462f-9297-98d2db1c3772',
  'b4b78478-e583-44a5-a4c7-e0658995dfd3',
  '933a5146-f718-4d2b-8aa9-f82e5549d398',
  '10c0f457-836b-46c0-a4e1-e8a4b0c3513c',
  'ddc6b00e-5bc8-4e97-8366-8498d0947c8c',
  '9b17fc01-7ba8-410c-9c1c-bea1f5ed7bd8',
  'cb9a52ad-5991-4556-8859-2ee68f90360d',
  'e3fa5b78-b703-4ae1-aeea-67afb6664b72',
  'e0c95668-1663-4c0f-a947-44f51535ee2c',
  '62336cd6-fe38-4af7-924f-4137540ffab5',
  '076d1bdb-7dab-449d-80ee-df0984282b5b',
  'caa2b578-f812-481a-b254-03c3ebed2edb',
  '26546aa6-f10f-47b1-8c45-18aac6f8f4b8',
  '4e952f26-c6f1-42fd-978e-190751388dc0',
  '0e9795ae-7272-4c09-b570-cd05876f68fe',
  '3b44d4a0-9e70-4e53-b49e-3f2b74fd4b51',
  'eddc62e2-36ed-4449-b650-6f6b199d89f2',
  '8cc1fa10-579f-448c-b126-1e16375b7c30',
  'ffa2c45a-67a8-4d14-ab78-a9cac091ef2f',
  '81b5d2d3-45a5-4593-96a7-53c6ad732dd8',
  '3d24a52f-f5ed-4bc6-aca4-de547e57365f',
  '72f01a5c-8f25-462a-af60-15e83d1f1dc8',
  '6e74e98d-3e49-4612-8211-18779af0769a',
  '90557424-eb20-4a84-a79f-0e2d5c5e5f6e',
  '25521919-c97f-435d-acc5-446112655200',
  'ad85a042-8d3a-4023-a751-96ffbb7961bc',
  '46b89259-792b-4fbd-9529-2d3144149b0d',
  '02d32c5a-17d0-4d79-ae1e-9b24d90fe2a3',
  '719830c1-65d1-4842-970e-cde639711708',
  '46c83777-26f8-406e-91c8-a7d9f48da0bd',
  '2ff3a2c7-94fb-4d09-853b-c30e70cbce6c',
  '3abee149-0c7f-4510-b56c-97356b34d505',
  '4d41696f-03e6-4171-bc0f-9586065ecd0c',
  '5d2632ec-29e8-4e64-afa6-b1ba389d661b',
  'f45d1315-e31c-4342-892d-c46d74a64666',
  '33f5c0d9-78de-43a0-8abd-94a273604588',
  '57b05e80-14ee-49fe-9dd4-8704df6a98b1',
  '9328a9a9-aa2c-404e-9eb7-46fb7c74edf1',
  '0db84da7-cfb7-4515-818f-07008be7363a',
  '31dad0fa-d7fd-4d19-8881-e7d39a7f4008',
  '7c6103c5-e4bc-451a-b942-88586fcdee2a',
  '9c81b041-e966-4066-a16d-dde403120995',
  'ae8eccfe-7578-4c6f-b015-ebd80df3967b',
  '40c4a2a6-7803-47d7-986e-bc119eb36e16',
  'a7aed567-7623-4851-acb4-b7099792c0bd',
  'a2cec010-93ae-44f1-8f06-c4165b269554',
  'd54c452e-175f-456e-a8a5-49e62c82c6fd',
  'a19d65cd-1f4c-486c-8099-bd061162a4c0',
  'a1c6d2b3-7721-4d56-9903-075d5e7a6ac3',
  'be9ad47e-ca4f-44f4-8b5a-9ef20e4a63b5',
  'f8a2f09a-197c-4780-bdb0-cfb8c7c2e1a3',
  'cbe9117e-3589-49ee-bb46-3043f4865f3b',
  'a6afab29-1221-4542-8440-a52625f7b33f',
  '1fee13c6-36e3-4a75-80a5-40b5c6954162',
  '3b0a95a5-1498-420d-95ac-9ad5171a32a8',
  'ce94836a-8446-44ed-903e-bdbb24d0c73c',
  '86064f66-f634-479f-af98-ac86385a0279',
  '7b5440e3-8a53-4a38-90fd-2c2180010557',
  '24606c81-46a2-4a0b-9d8e-cdd5fb88ac5d',
  '74223938-1022-44d7-b48a-ee276c6f6277',
  '3354cc3d-384d-45de-b5be-316a6080cd36',
  '2fa7dfb5-3982-48ff-8876-19d7bf0e8542',
  '5d22b9da-2df1-4c4d-bc24-476045240a4c',
  '959897ac-a80f-44a4-85bb-352f9a23db99',
  '328570b1-1de6-4081-ac7d-403d0184f5f3',
];

export const BOOST_READING_ASSET_BK = '210915e8-955b-4624-bbe0-a05b7e710dca';
export const BOOST_READING_TX_ASSET_BK = 'd790df98-adc0-4287-9d18-05b42758ee66';
// used to show Boost Reading app in k-5 view
export const BOOST_READING_ASSETS_BKS = [
  BOOST_READING_ASSET_BK,
  BOOST_READING_TX_ASSET_BK,
];

export const BOOST_LECTURA_ASSET_BK = '5a9d3e63-bc24-4cb0-9cbf-442f9d0b3368';
export const MCLASS_READING_ASSET_BK = '411d73b7-65a7-459a-bffe-078aab0deb50';
export const MCLASS_LECTURA_ASSET_BK = '9a5b9b7a-9035-4983-b6eb-8074052f4240';

// New mCLASS assets (should take priority over old asset)
export const NEW_MCLASS_ASSETS = [
  MCLASS_READING_ASSET_BK,
  MCLASS_LECTURA_ASSET_BK,
];

// is used to define student user grade
export const STUDENT_MIDDLE_SCHOOL_VIEW_ASSETS_BKS = [
  '1b9c7746-e2b1-4381-8f26-0bc7ef7e9217',
  '3decb843-95ac-4264-bdf7-7ab9022b6870',
  '1cd62859-2e7f-4a7c-b928-575b7b8910fe',
  '569aae93-f6b0-40b9-8ab4-1ba89327464f',
  '1fcad967-4656-4b63-98c6-566a44e19e9b',
  '09a07a8f-0669-4938-97ec-0e5f466b9874',
];

// Grade-based app visibility constants
export const BOOST_SPECIFIC_ASSET_IDS = [
  'af340753-88d9-4b06-b301-ae3fb7b816c6',
  'e5cc09bf-5794-4dc8-9a1d-2a58928272be',
  '74299b43-1ac3-422a-85bb-4210bbba7467',
  'ffec4b66-5e53-4aaa-b06c-bc616a77b9ab',
  'a507ecf4-d4c9-4a7e-8ade-1147c959adfc',
  '0606029c-78bd-48c3-8372-ce2d51051919',
  '285487bf-6d73-45f6-a05a-36dbef75ef9b',
  'ee72eba2-f4d1-4fef-ac26-75997b20316d',
  'd0a9820e-1157-4bcf-90bb-1d76e596624a',
  '8e8e1d56-854c-4662-9668-cd9e804a910a',
  '7d549dac-f21f-4f20-a539-5251b92d2ff5',
  '915e8323-f880-4310-8004-1bd8fb5c4292',
  '6804581c-831f-4133-923d-f7628a0695ca',
  '5d3ac72d-4b75-4c39-b9a1-485f08c2225d',
  '581c20a4-44c3-443b-9955-8b3c170bdbb2',
  'a0937a71-95cc-45b7-afd0-3fb567d9664a',
  'c161887b-1fa5-4379-a226-28b45c3ab8c9',
  'acd372d7-1d3f-456a-871a-2de47bcaaf4a',
  '49f49916-e98f-4992-9562-6b44ecf7c10e',
];

export const MCLASS_PRODUCT_NAMES = ['mCLASS DIBELS 8', 'mCLASS Lectura'];
